module.exports = __webpack_public_path__ + "img/8.664d4c6e.png";